import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { TRANSLATIONS } from "@/i18n/translations";

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const stored = typeof window !== "undefined" ? localStorage.getItem("chiessa_lang") : null;
    return stored === "en" ? "en" : "es";
  });

  useEffect(() => {
    try { localStorage.setItem("chiessa_lang", lang); } catch (_) { /* ignore */ }
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((path) => {
    const parts = path.split(".");
    let cur = TRANSLATIONS[lang];
    for (const p of parts) {
      if (cur && typeof cur === "object" && p in cur) cur = cur[p];
      else return path;
    }
    return cur;
  }, [lang]);

  const toggle = useCallback(() => setLang((l) => (l === "es" ? "en" : "es")), []);

  return (
    <I18nCtx.Provider value={{ lang, setLang, toggle, t }}>{children}</I18nCtx.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nCtx);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
